import React, { useEffect, useState, useRef, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { cloneDeep, isEmpty } from 'lodash';
import { round } from 'mathjs';

import '../scss/index.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moSalaryCity from './store';
import PDF from '../../../component/pdf';
import Title from '../../../component/title';
import HeadPdf from '../../../component/head-pdf';
import FootPdf from '../../../component/foot-pdf';
import moIndex from '../../../store/index';
import IndicatorTable from '../../indicator-table';
import Table from './table';
import Explain from './explain';
import ExplainPDF from './explain-pdf';

interface IProps {}
interface IState {}

const TablePDF = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry } = moIndex;
  const { tableHead, tableLeft, tableRight, xData } = moSalaryCity;

  const calcLog = () => {
    const leftArr: any[] = cloneDeep(tableLeft.slice(26));
    const rightArr: any[] = cloneDeep(tableRight.slice(26));
    const text: any[] = [];
    for (let i = 0; i < Math.ceil(leftArr.length / 26); i += 1) {
      const leftData = leftArr.slice(26 * i + 26 * i, 26 * i + 26 * i + 26);
      const rightData = rightArr.slice(26 * i + 26 * i, 26 * i + 26 * i + 26);
      text.push(
        <PDF key={i}>
          <section className="salary-up-pdf_1010">
            <HeadPdf onetitle="人力资源核心指标" twotitle={industry.name} />
            <section className="content-salary-1001">
              <section className="title-1001">
                <Title title="涨薪率 - 按城市" bigTitle="人力指标" tag={industry.name} />
              </section>

              <IndicatorTable type="城市" tableHead={tableHead}
                tableLeft={leftData} tableRight={rightData} />

              {i === Math.floor(leftArr.length / 26) ? (
                <>
                  {tableLeft.length % 26 <= 20 ? <Explain /> : null}
                </>
              ) : null}
            </section>
            <FootPdf />
          </section>
        </PDF>,
      );
    }
    return text;
  };

  useEffect(() => {
    // console.log('table left -- ', toJS(tableLeft));
    // console.log('table right -- ', toJS(tableRight));

    return () => {};
  }, []);

  return (
    <>
      <Table />
      {tableRight.length > 26 ? calcLog() : null}
      {tableLeft.length % 26 > 20 ? <ExplainPDF /> : null}
    </>
  );
};

export default observer(TablePDF);
